import { Typography } from "@mui/material";
import clsx from "clsx";
import { isValidElement } from "react";

function IconText(props: any) {
  return (
    <div className={"iconTextContainer"} style={props.style}>
      {props.icon ? <span>{props.icon}</span> : false}
      <span>
        {isValidElement(props.text) ? (
          props.text
        ) : (
          <div className="smallCaption" style={{ color: props.textColor }}>
            {props.text}
          </div>
        )}
      </span>
      {props.right ? <div className="smallCaption">{props.right}</div> : false}
    </div>
  );
}

export default IconText;
